import React, { useState } from "react";
import { Card, Row, Col, Form } from "react-bootstrap";
import EmployeeStmtDetailsNew from "./EmployeeStmtDetailsNew";
import EmployeeSearchAdmin from "../../common/empsearch/EmployeeSearchAdmin";

const EmployeeOptionsStatement = ({ initialEmployeeId = null, onEmployeeChange = null }) => {
    const [selectedEmp, setSelectedEmp] = useState(null);
    const [userHasSelected, setUserHasSelected] = useState(false);
    const [includeTerminated, setIncludeTerminated] = useState(false);

    const handleEmployeeSelect = (emp) => {
        setSelectedEmp(emp);
        setUserHasSelected(true);
        if (onEmployeeChange && emp) {
            onEmployeeChange(emp.employeeId);
        }
    };

    const handleTerminatedRequired = () => {
        setIncludeTerminated(true);
    };

    // Use user selection if made, otherwise use URL employee ID
    const displayEmployeeId = userHasSelected ? selectedEmp?.employeeId : initialEmployeeId;
    const shouldShowData = displayEmployeeId != null;

    return (
        <div>
            <Row className="justify-content-left">
                <Col lg={6}>
                    <Card style={{marginTop: 25}}>
                        <Card.Body>
                            <Card.Title>Employee</Card.Title>
                            <Card.Text>
                                <EmployeeSearchAdmin
                                    onSelect={handleEmployeeSelect}
                                    initialEmployeeId={initialEmployeeId}
                                    includeTerminated={includeTerminated}
                                    onTerminatedRequired={handleTerminatedRequired}
                                />
                            </Card.Text>
                            <Form.Check
                                type="checkbox"
                                id="include-terminated"
                                label="Include terminated employees"
                                checked={includeTerminated}
                                onChange={(e) => setIncludeTerminated(e.target.checked)}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            {shouldShowData ?
                <Row className="justify-content-left">
                    <Col>
                        <EmployeeStmtDetailsNew employeeId={displayEmployeeId} />
                    </Col>
                </Row>
                : <Row><Col>Please select an employee...</Col></Row>
            }
        </div>
    );
};

export default EmployeeOptionsStatement;
